import React from 'react';


export default function PingMarker({positionX, positionY, isRemote = false})
{
    const [animating, setAnimating] = React.useState(false);

    React.useEffect(() => {
        if(positionX >= 0 && positionY >= 0)
        {
            setAnimating(false);
            setTimeout(() => setAnimating(true), 50);
        }
    }, [positionX, positionY]);

    return <div 
    className={"pingMarker"+ (animating ? " animated" : "" )+(isRemote ? " remoteUser" : "")}
    style={{left:(positionX*100)+"%", top: (positionY*100)+"%"}}
    onAnimationEnd={() => setAnimating(false)}

    />
}